module.exports = __webpack_public_path__ + "img/current-img-3.a25e0c3a.png";